module.exports = __webpack_public_path__ + "img/bgpic1.2936f760.png";